<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-poll-people" class="q-mb-sm" /> {{ $t('drills') }}
        </div>

        <q-tabs v-model="tab">
            <q-tab slot="title" name="basic-data" :label="$t('basic_data')" />
            <q-tab slot="title" name="questions" :label="$t('questions')" v-show="showTab" />
            <q-tab slot="title" name="configure-publish" :label="$t('configure_and_publish')" v-show="showTab" />

            <q-tab-pane name="basic-data">
                <basic-data @set_has_answers="setHasAnswers" />
            </q-tab-pane>

            <q-tab-pane name="questions" keep-alive>
                <questions :has_answers="has_answers" />
            </q-tab-pane>

            <q-tab-pane name="configure-publish">
                <configure-publish />
            </q-tab-pane>
        </q-tabs>
    </q-page>
</template>

<script>
import BasicData from 'components/admin/drills/BasicData'
import Questions from 'components/admin/drills/Questions'
import ConfigureAndPublish from 'components/admin/drills/ConfigureAndPublish'

export default {
    i18nOptions: { namespaces: ['common', 'drill', 'admin'] },
    
    data() {
        return {
            tab: 'basic-data',
            drill_id: 0,
            has_answers: false
        }
    },

    computed: {
        showTab() {
            if (this.drill_id != 0) return true
            else return false
        }
    },

    methods: {
        setHasAnswers(ha) {
            this.has_answers = ha
        }
    },

    components: {
        'basic-data': BasicData,
        'questions': Questions,
        'configure-publish': ConfigureAndPublish
    },

    watch: {
        '$route': function () {
            this.drill_id = this.$route.params.id
        }
    },

    created() {
        this.drill_id = this.$route.params.id
    }
}
</script>

<style>

</style>
